







import { Vue, Component } from 'vue-property-decorator';
import ToastContainer from '@/components/ToastContainer.vue';
import OverlayScrollbar from 'overlayscrollbars';
import 'nprogress/nprogress.css';

@Component({
  components: {
    ToastContainer,
  },
})
export default class App extends Vue {
  // eslint-disable-next-line class-methods-use-this
  updated() {
    OverlayScrollbar(document.getElementsByTagName('body')[0], {
      scrollbars: { autoHide: 'move' },
    });
  }
}
